import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { useFetch } from '../../../hooks/useFetch'
import { useEffect, useState } from 'react'
import { Container, Box, Grid, TextField, Typography, Button, Divider } from '@mui/material/'
import DashboardIcon from '@mui/icons-material/Dashboard';
import { NumericFormat } from 'react-number-format';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';
import { orderBy } from 'firebase/firestore'
import SelectConsult from '../../../components/SelectConsult'
import ViewConsultQuote from '../../../components/consult/ViewConsultQuote'
import ConsultOrderTotal from '../../../components/consult/ConsultOrderTotal'
function BookConsult() {

    const navigate = useNavigate()
    document.title = 'Private Candidates Online: Cambridge Assessment Application ';
    const { user, studentID } = useAuthContext()
    const [studentId, setStudentId] = useState(studentID)
    const [consultId, setConsultId] = useState('')
    const [viewQuote, setViewQuote] = useState(0)
    const [viewOrder, setViewOrder] = useState(0)
    const handleSubmit = (e) => {
        e.preventDefault()
        setViewQuote(1)
    }

    return (

        <>
            {!viewQuote && (

                <>



                    <form onSubmit={handleSubmit}>



                        < Container maxWidth="md"  >

                            <Box mb={5} />
                            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: 'primary.main', borderRadius: 2 }}>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                            Book Academic Consultation
                                        </Typography>



                                    </Box>


                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="body2" component="p" color="body2.main" sx={{ textAlign: 'center' }}>
                                            Should you have any academic, qualification, paper combination or general enquiry, you can book an online consultation and one of British Internationals College's academic consultants will assist you.
                                        </Typography>



                                    </Box>


                                </Grid>

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="body2" component="p" color="body2.main" sx={{ textAlign: 'left' }}>
                                            Please note the following:

                                            <ul>

                                                <li>Consultations are booked at a fee and are non-refundable.</li>
                                                <li>Consultations are strictly online as per schedule.</li>
                                                <li>Consultations are based on an individual’s academic history. There, prior to attending a consultation, BIC requires that candidate obtain a copy of their course syllabus and list of current certifications in order to adequately advise the candidate on a path forward.</li>
                                                <li>BIC will take no responsibility for advice based on incorrectly supplied or partial information. Candidates must ensure they supply accurate information.</li>

                                            </ul>
                                        </Typography>



                                    </Box>


                                </Grid>

                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Typography variant="body2" component="p" color="body2.main" sx={{ textAlign: 'center' }}>
                                            To book a consolation, select an available date and time.
                                        </Typography>



                                    </Box>


                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}
                                            >
                                                <SelectConsult consultId={consultId} setConsultId={setConsultId} />

                                            </Box>


                                        </Grid>


                                    </Box>


                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}
                                            >
                                                <Button fullWidth variant="contained" type="submit">Generate Quote <DashboardIcon /></Button>


                                            </Box>


                                        </Grid>

                                    </Box>

                                    <Box mb={5} />
                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >


                                    </Box>

                                    <Box mb={5} />
                                </Grid>
                                <Grid item xs={12}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{

                                                    maxWidth: '95%',
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto'
                                                }}
                                            >
                                                <Button fullWidth variant="contained" onClick={(e) => navigate('/cambridge')}>Dashboard <DashboardIcon /></Button>


                                            </Box>


                                        </Grid>

                                    </Box>

                                    <Box mb={5} />
                                </Grid>
                            </Grid>
                        </Container>

                    </form>
                </>
            )
            }

            {viewQuote === 1 && !viewOrder && (

                <ViewConsultQuote studentId={studentId} consultId={consultId} setViewOrder={setViewOrder} setViewQuote={setViewQuote} />
            )}

            {viewOrder === 1 && (

                <ConsultOrderTotal studentId={studentId} consultId={consultId} />
            )}
        </>
    )
}

export default BookConsult